import React, { useState, useEffect } from 'react';
import useManageOrder from '../order/useManageOrder';
import useGetCustomerProfile from '../../hooks/useGetCustomerProfile';
import ProfileCombo from '../../sharedComponents/ProfileCombo';
import PaymentTextArea from '../../sharedComponents/PaymentTextArea';
import OrderSummaryTable from '../../sharedComponents/OrderSummaryTable';
import CircularProgress from '@mui/material/CircularProgress';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { extractUrls } from '../../services/UrlValidationService';

function CollectMoneyPerson() {
  const { orders, orderSummary, isLoading, error, getOrderSummaryByUrls, createSecondOrderPaymentLink } = useManageOrder();
  const { profiles, getCustomerProfiles } = useGetCustomerProfile();
  const [formData, setFormData] = useState({
    smileName: "",
    urls: ""
  });
  const shopName = useSelector((state) => state.shop.name);

  // Load customer profiles on component mount
  useEffect(() => {
    getCustomerProfiles();
  }, []);

  useEffect(() => {
    console.log(orderSummary)
  }, [orderSummary])

  const calculateTextAreaRows = (text) => {
    const lineCount = text.split('\n').length;
    const additionalPadding = 1;
    return lineCount + additionalPadding;
  };

  const textAreaRows = calculateTextAreaRows(formData.urls);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!formData.smileName || !formData.urls.trim()) {
      toast.error("กรุณากรอกชื่อและ URLs");
      return;
    }

    try {
      // Use UrlValidationService to extract URLs
      const urlArray = extractUrls(formData.urls);
      
      if (urlArray.length === 0) {
        toast.error("ไม่พบ URLs ที่ถูกต้อง กรุณาตรวจสอบรูปแบบ URL");
        return;
      }

      const shop = shopName === 'tama' ? 'tama' : 'smile';
      const isSuccess = await getOrderSummaryByUrls({
        smileName: formData.smileName,
        urls: urlArray,
        shop: shop
      });

      if (isSuccess) {
        toast.success("ดึงข้อมูลสำเร็จ");
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleDataChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleProfileChange = (selectedProfile) => {
    setFormData({ ...formData, smileName: selectedProfile });
  };

  return (
    <div className="flex gap-8">
      {/* Left Section - Input Form (1/3 width) */}
      <div className="w-1/3 bg-white rounded-lg shadow-md p-6">
        
        <form id="collect-money-form" onSubmit={handleFormSubmit} className="space-y-6">
          <div>
            <ProfileCombo 
              profiles={profiles || []}
              onChange={handleProfileChange}
            />
          </div>
          
          <div>
            <label htmlFor="urls" className="block text-sm font-medium text-gray-700 mb-2">
              กรอก URLs (หนึ่ง URL ต่อบรรทัด)
            </label>
            <textarea
              id="urls"
              name="urls"
              value={formData.urls || ""}
              onChange={handleDataChange}
              className="w-full p-3 border border-gray-300 rounded-lg resize-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              rows={10 || textAreaRows}
              placeholder="https://example.com/order1&#10;https://example.com/order2&#10;https://example.com/order3"
            />
          </div>
          
          <div>
            <button 
              type="submit" 
              className="w-full bg-blue-600 text-white py-3 px-4 rounded-lg hover:bg-blue-700 transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={isLoading}
            >
              {isLoading ? (
                <div className="flex items-center justify-center">
                  <CircularProgress size={20} className="mr-2" />
                  กำลังดึงข้อมูล...
                </div>
              ) : (
                'ดึงข้อมูล'
              )}
            </button>
          </div>
        </form>
        
        {error && (
          <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg">
            <p className='text-red-600 text-sm'>{error}</p>
          </div>
        )}
      </div>

      {/* Right Section - Results (2/3 width) */}
      <div className="flex-1 bg-white rounded-lg shadow-md p-6">
        
        {orders && orders.length > 0 && orderSummary ? (
          <div className="space-y-6">
            {/* Order Summary Table */}
            <div>
              <h3 className="text-lg font-medium text-gray-700 mb-4">รายการสั่งซื้อ</h3>
              <OrderSummaryTable
                smileName={formData.smileName}
                orders={orders}
                orderSummary={orderSummary}
                createSecondOrderPaymentLink={createSecondOrderPaymentLink}
                isAdmin={false}
              />
            </div>
          </div>
        ) : (
          <div className="text-center py-12">
            <div className="text-gray-400 text-6xl mb-4">📋</div>
            <p className="text-gray-500 text-lg">
              กรุณาเลือกลูกค้าและกรอก URLs เพื่อดึงข้อมูล
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default CollectMoneyPerson;
